import React from 'react';
import useTag from '../../hooks/useTag';

export default function Footer() {
  const tag = useTag();
  return (
    <>
      <div className='footer-content'>
        <span>Powered by&nbsp;</span>
        <a href='https://water.noaa.gov' target='_blank' rel='noreferrer'>
          The National Water Model
        </a>
        <span>.&nbsp;&nbsp;Built by&nbsp;</span>
        <a href='https://dewberry.com' target='_blank' rel='noreferrer'>
          Dewberry
        </a>
        <span>.</span>
        {tag && (
          <span className='version-tag'>
            <a
              href={`https://github.com/Dewberry/fcast-dashboard/releases/tag/${tag}`}
            >
              {tag}
            </a>
          </span>
        )}
      </div>
    </>
  );
}
